import initialState from './state'

export default {
  addConfiguration (state, configuration) {
    state.configurations.push(configuration)
  },
  removeConfiguration (state, configurationId) {
    const configurations = [...state.configurations]
    const index = configurations.findIndex(x => x.id === configurationId)

    if (index !== -1) {
      configurations.splice(index, 1)
      state.configurations = configurations
    }
  },
  updateConfiguration (state, { id, configuration }) {
    const index = state.configurations.findIndex(x => x.id === id)

    if (index === -1) {
      throw new Error(`Could not find configuration with id ${id}`)
    }

    state.configurations = Object.assign([], state.configurations, {
      [index]: configuration,
    })
  },
  clearConfigurations (state) {
    state.configurations = []
  },
  setOrderQuoteModalVisible (state, visible) {
    state.orderQuoteModalVisible = visible
  },
  setConfigurationSent (state, type) {
    state.configurationSent = type
  },
  setConfigurationType (state, type) {
    state.configurationType = type
  },
  setStaticPages (state, pages) {
    state.staticPages = pages
  },
  setCompanyInfo (state, companyInfo) {
    state.companyInfo = companyInfo
  },
  setInitialized (state, initialized) {
    state.initialized = initialized
  },
  setConfirmModal (state, data) {
    state.confirmModal = data
  },
  openConfirmModal (state, { message, onConfirm, onCancel }) {
    state.confirmModal = {
      ...state.confirmModal,
      message,
      onConfirm,
      onCancel,
      visible: true,
    }
  },
  resetConfirmModal (state) {
    state.confirmModal = initialState().confirmModal
  },
  clearFiles (state) {
    state.files = []
  },
  openConfigurationsSidebar (state) {
    state.configurationsSidebar.open = true
  },
  hideConfigurationsSidebar (state) {
    state.configurationsSidebar.open = false
  },
}
